import React from "react";
import { Link } from "react-router-dom";

export default class AllFeatures extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        {/* Start Feature Four */}
        <section className="feature-four">
          <div className="container">
            <div className="sec-title text-center">
              <div className="sec-title__tagline">
                <span className="left"></span>
                <h6>Naše specijalizirane usluge </h6>{" "}
                <span className="right"></span>
              </div>
              <h2 className="sec-title__title">Nudimo vrhunske usluge</h2>
            </div>
            <div className="row">
              {/* Start Feature Four Single */}
              <div className="col-xl-4">
                <div className="feature-four__single style2 text-center">
                  <div className="feature-four__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <div className="feature-four__single-content">
                    <h2>
                      <Link to={process.env.PUBLIC_URL + `/services`}>
                        Tesarski radovi
                      </Link>
                    </h2>
                    <p>
                      Stručno izvedeni radovi šalovanja, oplate i drugih
                      tesarskih elemenata ključnih za kvalitetnu gradnju i
                      betoniranje.
                    </p>
                  </div>
                </div>
              </div>
              {/* End Feature Four Single */}

              {/* Start Feature Four Single */}
              <div className="col-xl-4">
                <div className="feature-four__single style2 text-center">
                  <div className="feature-four__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <div className="feature-four__single-content">
                    <h2>
                      <Link to={process.env.PUBLIC_URL + `/services`}>
                        Zidarski radovi
                      </Link>
                    </h2>
                    <p>
                      Precizno i kvalitetno zidanje objekata, koristeći
                      različite materijale i tehnike za maksimalnu stabilnost i
                      dugotrajnost.
                    </p>
                  </div>
                </div>
              </div>
              {/* End Feature Four Single */}

              {/* Start Feature Four Single */}
              <div className="col-xl-4">
                <div className="feature-four__single style2 text-center">
                  <div className="feature-four__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <div className="feature-four__single-content">
                    <h2>
                      <Link to={process.env.PUBLIC_URL + `/services`}>
                        Krovopokrivački radovi
                      </Link>
                    </h2>
                    <p>
                      Izrada krovnih konstrukcija, završni radovi na krovu za
                      potpunu zaštitu objekta.
                    </p>
                  </div>
                </div>
              </div>
              {/* End Feature Four Single */}

              {/* Start Feature Four Single */}
              <div className="col-xl-4">
                <div className="feature-four__single style2 text-center">
                  <div className="feature-four__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <div className="feature-four__single-content">
                    <h2>
                      <Link to={process.env.PUBLIC_URL + `/services`}>
                        Rigips radovi
                      </Link>
                    </h2>
                    <p>
                      Profesionalna montaža gipsanih ploča za pregradne zidove,
                      spuštene plafone i dekorativne obloge.
                    </p>
                  </div>
                </div>
              </div>
              {/* End Feature Four Single */}

              {/* Start Feature Four Single */}
              <div className="col-xl-4">
                <div className="feature-four__single style2 text-center">
                  <div className="feature-four__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <div className="feature-four__single-content">
                    <h2>
                      <Link to={process.env.PUBLIC_URL + `/services`}>
                        Molerski radovi
                      </Link>
                    </h2>
                    <p>
                      Završna obrada zidova i plafona, uključujući krečenje,
                      gletovanje i dekorativne tehnike prema vašim željama.
                    </p>
                  </div>
                </div>
              </div>
              {/* End Feature Four Single */}

              {/* Start Feature Four Single */}
              <div className="col-xl-4">
                <div className="feature-four__single style2 text-center">
                  <div className="feature-four__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <div className="feature-four__single-content">
                    <h2>
                      <Link to={process.env.PUBLIC_URL + `/services`}>
                        Keramičarski radovi
                      </Link>
                    </h2>
                    <p>
                      Precizno postavljanje pločica u enterijerima i
                      eksterijerima, uz pažljivo fugovanje i završnu obradu.
                    </p>
                  </div>
                </div>
              </div>
              {/* End Feature Four Single */}

              {/* Start Feature Four Single */}
              <div className="col-xl-4">
                <div className="feature-four__single style2 text-center">
                  <div className="feature-four__single-icon">
                    <span className="icon-interior-design-1"></span>
                  </div>
                  <div className="feature-four__single-content">
                    <h2>
                      <Link to={process.env.PUBLIC_URL + `/services`}>
                        Usluge 3D dizajna prostora
                      </Link>
                    </h2>
                    <p>
                      Realistični 3D prikazi prostora koji omogućavaju bolju
                      vizualizaciju projekta prije početka radova.
                    </p>
                  </div>
                </div>
              </div>
              {/* End Feature Four Single */}
            </div>
          </div>
        </section>
        {/* End Feature Four */}
      </>
    );
  }
}
